export default "/img/UA.4b5d0bd7ad4d62b35e0da88b41494112.png";